import React from 'react';
import { Tooltip } from 'antd';

/**
 * `maxTagPlaceholder` renderer for the worklist multi-select filters (which use
 * `maxTagCount={1}` + the `single-line-tags` class to stay one row tall).
 *
 * Renders the collapsed "+N ..." chip with a tooltip listing every hidden
 * selection, so the user can see the full set on hover without the control
 * growing. Shared across all filter selects for consistency.
 */
export const maxTagTooltip = (omittedValues: { label?: React.ReactNode }[]) => (
  <Tooltip
    title={
      <div style={{ maxHeight: 240, overflowY: 'auto' }}>
        {omittedValues.map((o, i) => (
          <div key={i}>{o?.label}</div>
        ))}
      </div>
    }
  >
    <span>+ {omittedValues.length} ...</span>
  </Tooltip>
);
